import type { ReactNode } from "react"
import { adminSections } from "../../../components/cares/admin/config";
import { adminSettingsSections } from "../../../components/cares/admin-settings/config";
import { getCaresShellBootstrap } from "../../../components/cares/shell/bootstrap";
import { myScheduleSections } from "../../../components/cares/my-schedule/config";
import { schedulerReviewSections } from "../../../components/cares/scheduler-review/config";

const DashboardsIcon = <i className="bi bi-house side-menu__icon"></i>

const PagesIcon = <i className="bi bi-file-earmark side-menu__icon"></i>

const AuthenticationIcon = <i className="bi bi-key side-menu__icon"></i>

const ErrorIcon = <i className="bi bi-exclamation-triangle side-menu__icon"></i>

const AppsIcon = <i className="bi bi-grid side-menu__icon"></i>

const NestedMenu = <i className="bi bi-layers side-menu__icon"></i>

const UIElements = <i className="bi bi-archive side-menu__icon"></i>

const Utilities = <i className="bi bi-award side-menu__icon"></i>

const Forms = <i className="bi bi-file-earmark-text side-menu__icon"></i>

const AdvancedUI = <i className="bi bi-snow side-menu__icon"></i>

const Widgets = <i className="bi bi-gift side-menu__icon"></i>

const Tables = <i className="bi bi-layout-text-window side-menu__icon"></i>

const Charts = <i className="bi bi-bar-chart side-menu__icon"></i>

const Maps = <i className="bi bi-geo-alt side-menu__icon"></i>

const Icons = <i className="bi bi-shop side-menu__icon"></i>

const AdminIcon = <i className="bi bi-shield-lock side-menu__icon"></i>

const MyDashboardIcon = <i className="bi bi-grid-1x2 side-menu__icon"></i>

const SchedulingIcon = <i className="bi bi-calendar-week side-menu__icon"></i>

const AdminSettingsIcon = <i className="bi bi-sliders side-menu__icon"></i>

const UserSettingsIcon = <i className="bi bi-person-gear side-menu__icon"></i>

const FaqIcon = <i className="bi bi-question-circle side-menu__icon"></i>

export type Menuitemtype = {
    menutitle?: string;
    title?: string;
    icon?: ReactNode;
    menusub?: boolean;
    type: "sub" | "empty" | "link";
    active: boolean;
    selected: boolean;
    dirchange: boolean;
    children?: Menuitemtype[];
    path?: string;
};

const TemplateItemsIcon = <i className="bi bi-collection side-menu__icon"></i>

const TEMPLATE_MENU_ITEMS: Menuitemtype[] = [
    {
        title: "Dashboards", icon: DashboardsIcon, type: "sub", menusub: true, active: false, selected: false, dirchange: false,
        children: [
            { path: `/dashboards/sales`, type: "link", active: false, selected: false, dirchange: false, title: "Sales", },
            { path: `/dashboards/analytics`, type: "link", active: false, selected: false, dirchange: false, title: "Analytics" },
            { path: `/dashboards/ecommerce`, type: "link", active: false, selected: false, dirchange: false, title: "Ecommerce" },
            { path: `/dashboards/crm`, type: "link", active: false, selected: false, dirchange: false, title: "CRM" },
            { path: `/dashboards/hrm`, type: "link", active: false, selected: false, dirchange: false, title: "HRM" },
            { path: `/dashboards/nft`, type: "link", active: false, selected: false, dirchange: false, title: "NFT" },
            { path: `/dashboards/crypto`, type: "link", active: false, selected: false, dirchange: false, title: "Crypto" },
            { path: `/dashboards/jobs`, type: "link", active: false, selected: false, dirchange: false, title: "Jobs" },
            { path: `/dashboards/project`, type: "link", active: false, selected: false, dirchange: false, title: "Projects" },
            { path: `/dashboards/course`, type: "link", active: false, selected: false, dirchange: false, title: "Courses" },
            { path: `/dashboards/stock`, type: "link", active: false, selected: false, dirchange: false, title: "Stocks" },
            { path: `/dashboards/personal`, type: "link", active: false, selected: false, dirchange: false, title: "Personal" },
            { path: `/dashboards/customer`, type: "link", active: false, selected: false, dirchange: false, title: "Customer" },
        ],
    },

    {
        title: "Pages", icon: PagesIcon, type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [

            {
                title: "Blog", type: "sub", active: false, menusub: true, selected: false, dirchange: false, children: [
                    { path: `/pages/blog/blog`, type: "link", active: false, selected: false, dirchange: false, title: "Blog" },
                    { path: `/pages/blog/blogdetail`, type: "link", active: false, selected: false, dirchange: false, title: "Blog Details" },
                    { path: `/pages/blog/createblog`, type: "link", active: false, selected: false, dirchange: false, title: "Create Blog" },

                ],
            },
            { path: `/pages/chat`, type: "link", active: false, selected: false, dirchange: false, title: "Chat" },
            { path: `/pages/contact`, type: "link", active: false, selected: false, dirchange: false, title: "Contacts" },
            { path: `/pages/contactus`, type: "link", active: false, selected: false, dirchange: false, title: "Contact Us" },
            {
                title: "Ecommerce", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/pages/ecommerce/addproduct`, type: "link", active: false, selected: false, dirchange: false, title: "Add Products" },
                    { path: `/pages/ecommerce/cart`, type: "link", active: false, selected: false, dirchange: false, title: "Cart" },
                    { path: `/pages/ecommerce/checkout`, type: "link", active: false, selected: false, dirchange: false, title: "Checkout" },
                    { path: `/pages/ecommerce/editproduct`, type: "link", active: false, selected: false, dirchange: false, title: "Edit products" },
                    { path: `/pages/ecommerce/oderdetails`, type: "link", active: false, selected: false, dirchange: false, title: "Order Details" },
                    { path: `/pages/ecommerce/order`, type: "link", active: false, selected: false, dirchange: false, title: "Orders" },
                    { path: `/pages/ecommerce/product`, type: "link", active: false, selected: false, dirchange: false, title: "Products" },
                    { path: `/pages/ecommerce/productdetails`, type: "link", active: false, selected: false, dirchange: false, title: "Product Details" },
                    { path: `/pages/ecommerce/productlist`, type: "link", active: false, selected: false, dirchange: false, title: "Products List" },
                    { path: `/pages/ecommerce/wishlist`, type: "link", active: false, selected: false, dirchange: false, title: "Wishlist" },

                ],
            },
            {
                title: "Email", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/pages/email/mailapp`, type: "link", active: false, selected: false, dirchange: false, title: "Mail App" },
                    { path: `/pages/email/mailsetting`, type: "link", active: false, selected: false, dirchange: false, title: "Mail Settings" },
                ],
            },
            { path: `/pages/empty`, type: "link", active: false, selected: false, dirchange: false, title: "Empty" },
            { path: `/pages/faq's`, type: "link", active: false, selected: false, dirchange: false, title: "FAQ's" },
            {
                title: "File Manager", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/pages/filemanager/filemanager`, type: "link", active: false, selected: false, dirchange: false, title: "File Manager" },
                ],
            },
            {
                title: "Invoice", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/pages/invoice/createinvoice`, type: "link", active: false, selected: false, dirchange: false, title: "Create Invoice" },
                    { path: `/pages/invoice/invoicedetail`, type: "link", active: false, selected: false, dirchange: false, title: "Invoice Details" },
                    { path: `/pages/invoice/invoicelist`, type: "link", active: false, selected: false, dirchange: false, title: "Invoice List" },

                ],
            },
            { path: `/pages/landing`, type: "link", active: false, selected: false, dirchange: false, title: "Landing" },
            { path: `/pages/joblanding`, type: "link", active: false, selected: false, dirchange: false, title: "Jobs Landing" },
            { path: `/pages/notification`, type: "link", active: false, selected: false, dirchange: false, title: "Notifications" },
            { path: `/pages/pricing`, type: "link", active: false, selected: false, dirchange: false, title: "Pricing" },
            { path: `/pages/profile`, type: "link", active: false, selected: false, dirchange: false, title: "Profile" },
            { path: `/pages/review`, type: "link", active: false, selected: false, dirchange: false, title: "Reviews" },
            { path: `/pages/team`, type: "link", active: false, selected: false, dirchange: false, title: "Team" },
            { path: `/pages/termcondition`, type: "link", active: false, selected: false, dirchange: false, title: "Terms & Conditions" },
            { path: `/pages/timeline`, type: "link", active: false, selected: false, dirchange: false, title: "Timeline" },
            { path: `/pages/todolist`, type: "link", active: false, selected: false, dirchange: false, title: "To Do List" }
        ],
    },

    {
        title: "Authentication", icon: AuthenticationIcon, type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
            { path: `/authentication/coming-soon`, type: "link", active: false, selected: false, dirchange: false, title: "coming Soon" },
            {
                title: "Create Password", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/authentication/createpassword/create-password-basic`, type: "link", active: false, selected: false, dirchange: false, title: "Basic" },
                    { path: `/authentication/createpassword/create-password-cover`, type: "link", active: false, selected: false, dirchange: false, title: "Cover" },
                ],
            },
            {
                title: "Lock Screen", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/authentication/lockscreen/lockscreen-basic`, type: "link", active: false, selected: false, dirchange: false, title: "Basic" },
                    { path: `/authentication/lockscreen/lockscreen-cover`, type: "link", active: false, selected: false, dirchange: false, title: "Cover" },
                ],
            },
            {
                title: "Reset Password", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/authentication/resetpassword/reset-password-basic`, type: "link", active: false, selected: false, dirchange: false, title: "Basic" },
                    { path: `/authentication/resetpassword/reset-password-cover`, type: "link", active: false, selected: false, dirchange: false, title: "Cover" },
                ],
            },
            {
                title: "Sign Up", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/authentication/signup/sign-up-basic`, type: "link", active: false, selected: false, dirchange: false, title: "Basic" },
                    { path: `/authentication/signup/sign-up-cover`, type: "link", active: false, selected: false, dirchange: false, title: "Cover" },
                ],
            },
            {
                title: "Sign In", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/authentication/signin/sign-in-basic`, type: "link", active: false, selected: false, dirchange: false, title: "Basic" },
                    { path: `/authentication/signin/sign-in-cover`, type: "link", active: false, selected: false, dirchange: false, title: "Cover" },
                ],
            },
            {
                title: "Two Step Verification", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/authentication/twostepverification/two-step-verification-basic`, type: "link", active: false, selected: false, dirchange: false, title: "Basic" },
                    { path: `/authentication/twostepverification/two-step-verification-cover`, type: "link", active: false, selected: false, dirchange: false, title: "Cover" },
                ],
            },
            { path: `/authentication/under-maintenance`, type: "link", active: false, selected: false, dirchange: false, title: "Under Maintenance" }
        ],
    },

    {
        title: "Error", icon: ErrorIcon, menusub: true, type: "sub", active: false, selected: false, dirchange: false, children: [
            { path: `/error/error401`, type: "link", active: false, selected: false, dirchange: false, title: "401-Error" },
            { path: `/error/error404`, type: "link", active: false, selected: false, dirchange: false, title: "404-Error" },
            { path: `/error/error500`, type: "link", active: false, selected: false, dirchange: false, title: "500-Error" },
        ],
    },

    {
        title: "Apps", icon: AppsIcon, type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
            { path: `/app/fullcalender`, type: "link", active: false, selected: false, dirchange: false, title: "Full Calender" },
            { path: `/app/gallery`, type: "link", active: false, selected: false, dirchange: false, title: "Gallery" },
            { path: `/app/sweetalert`, type: "link", active: false, selected: false, dirchange: false, title: "Sweet Alerts" },

            {
                title: "Projects", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/app/projects/projectlist`, type: "link", active: false, selected: false, dirchange: false, title: "Projects List" },
                    { path: `/app/projects/projectoverview`, type: "link", active: false, selected: false, dirchange: false, title: "Project Overview" },
                    { path: `/app/projects/createproject`, type: "link", active: false, selected: false, dirchange: false, title: "Create Project" },
                ],
            },
            {
                title: "Task", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/app/task/kanbanboard`, type: "link", active: false, selected: false, dirchange: false, title: "Kanban Board" },
                    { path: `/app/task/listview`, type: "link", active: false, selected: false, dirchange: false, title: "List View" },
                    { path: `/app/task/taskdetails`, type: "link", active: false, selected: false, dirchange: false, title: "Task Details" },
                ],
            },
            {
                title: "Jobs", type: "sub", menusub: true, active: false, selected: false, dirchange: false,
                children: [
                    { path: `/app/jobs/jobdetails`, type: "link", active: false, selected: false, dirchange: false, title: "Job Details" },
                    { path: `/app/jobs/searchcompany`, type: "link", active: false, selected: false, dirchange: false, title: "Search Company" },
                    { path: `/app/jobs/searchjob`, type: "link", active: false, selected: false, dirchange: false, title: "Search Jobs" },
                    { path: `/app/jobs/jobpost`, type: "link", active: false, selected: false, dirchange: false, title: "Job Post" },
                    { path: `/app/jobs/joblist`, type: "link", active: false, selected: false, dirchange: false, title: "Jobs List" },
                    { path: `/app/jobs/searchcandidate`, type: "link", active: false, selected: false, dirchange: false, title: "Search Candidate" },
                    { path: `/app/jobs/candidatedetails`, type: "link", active: false, selected: false, dirchange: false, title: "Candidate Details" },
                ],
            },
            {
                title: "NFT", type: "sub", menusub: true, active: false, selected: false, dirchange: false,
                children: [
                    { path: `/app/nft/marketplace`, type: "link", active: false, selected: false, dirchange: false, title: "Market Place" },
                    { path: `/app/nft/nftdetails`, type: "link", active: false, selected: false, dirchange: false, title: "NFT Details" },
                    { path: `/app/nft/createnft`, type: "link", active: false, selected: false, dirchange: false, title: "Create NFT" },
                    { path: `/app/nft/walletintegration`, type: "link", active: false, selected: false, dirchange: false, title: "Wallet Integration" },
                    { path: `/app/nft/liveauction`, type: "link", active: false, selected: false, dirchange: false, title: "Live Auction" },
                ],
            },
            {
                title: "CRM", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
                    { path: `/app/crm/crmcontact`, type: "link", active: false, selected: false, dirchange: false, title: "Contacts", },
                    { path: `/app/crm/companies`, type: "link", active: false, selected: false, dirchange: false, title: "Companies", },
                    { path: `/app/crm/deals`, type: "link", active: false, selected: false, dirchange: false, title: "Deals", },
                    { path: `/app/crm/leads`, type: "link", active: false, selected: false, dirchange: false, title: "Leads", },
                ],
            },
            {
                title: "Crypto", type: "sub", menusub: true, active: false, selected: false, dirchange: false,
                children: [
                    { path: `/app/crypto/transaction`, type: "link", active: false, selected: false, dirchange: false, title: "Transactions" },
                    { path: `/app/crypto/currencyexchange`, type: "link", active: false, selected: false, dirchange: false, title: "Currency Exchange" },
                    { path: `/app/crypto/buysell`, type: "link", active: false, selected: false, dirchange: false, title: "Buy & sell" },
                    { path: `/app/crypto/marketcap`, type: "link", active: false, selected: false, dirchange: false, title: "Marketcap" },
                    { path: `/app/crypto/wallet`, type: "link", active: false, selected: false, dirchange: false, title: "wallet" },
                ],
            },
        ],
    },

    {
        title: "Nested Menu", icon: NestedMenu, menusub: true, type: "sub", active: false, selected: false, dirchange: false, children: [

            { path: `/`, title: "Nested-1", type: "empty", active: false, selected: false, dirchange: false },

            {
                title: "Nested-2", type: "sub", active: false, selected: false, dirchange: false, children: [
                    { path: `/`, type: "empty", active: false, selected: false, dirchange: false, title: "Nested-2-1" },
                    { path: `/`, type: "empty", active: false, selected: false, dirchange: false, title: "Nested-2-2" },
                    { path: `/`, type: "empty", active: false, selected: false, dirchange: false, title: "Nested-2-3" },
                ],
            },
        ],
    },


    {
        title: "UI Elements", icon: UIElements, type: "sub", menusub: true, active: false, selected: false, dirchange: false,
        children: [
            { path: `/uielement/alerts`, type: "link", active: false, selected: false, dirchange: false, title: "Alerts" },
            { path: `/uielement/badges`, type: "link", active: false, selected: false, dirchange: false, title: "Badge" },
            { path: `/uielement/breadcrumb`, type: "link", active: false, selected: false, dirchange: false, title: "Breadcrumb" },
            { path: `/uielement/buttons`, type: "link", active: false, selected: false, dirchange: false, title: "Buttons" },
            { path: `/uielement/buttongroups`, type: "link", active: false, selected: false, dirchange: false, title: "Button Group" },
            { path: `/uielement/cards`, type: "link", active: false, selected: false, dirchange: false, title: "Cards" },
            { path: `/uielement/dropdowns`, type: "link", active: false, selected: false, dirchange: false, title: "Dropdowns" },
            { path: `/uielement/images-figures`, type: "link", active: false, selected: false, dirchange: false, title: "Images & Figures" },
            { path: `/uielement/listgroup`, type: "link", active: false, selected: false, dirchange: false, title: "List Group" },
            { path: `/uielement/navtabs`, type: "link", active: false, selected: false, dirchange: false, title: "Navs & Tabs" },
            { path: `/uielement/objectfit`, type: "link", active: false, selected: false, dirchange: false, title: "Object Fit" },
            { path: `/uielement/paginations`, type: "link", active: false, selected: false, dirchange: false, title: "Pagination" },
            { path: `/uielement/popovers`, type: "link", active: false, selected: false, dirchange: false, title: "Popovers" },
            { path: `/uielement/progressbar`, type: "link", active: false, selected: false, dirchange: false, title: "Progress" },
            { path: `/uielement/spinners`, type: "link", active: false, selected: false, dirchange: false, title: "Spinners" },
            { path: `/uielement/toasts`, type: "link", active: false, selected: false, dirchange: false, title: "Toasts" },
            { path: `/uielement/tooltips`, type: "link", active: false, selected: false, dirchange: false, title: "Tooltips" },
            { path: `/uielement/typographys`, type: "link", active: false, selected: false, dirchange: false, title: "Typography" },
        ],
    },


    {
        title: "Utilities", icon: Utilities, type: "sub", menusub: true, active: false, selected: false, dirchange: false,
        children: [
            { path: `/utilities/avatars`, type: "link", active: false, selected: false, dirchange: false, title: "Avatars" },
            { path: `/utilities/borders`, type: "link", active: false, selected: false, dirchange: false, title: "Borders" },
            { path: `/utilities/breakpoints`, type: "link", active: false, selected: false, dirchange: false, title: "Breakpoints" },
            { path: `/utilities/colors`, type: "link", active: false, selected: false, dirchange: false, title: "Colors" },
            { path: `/utilities/columns`, type: "link", active: false, selected: false, dirchange: false, title: "Columns" },
            { path: `/utilities/flex`, type: "link", active: false, selected: false, dirchange: false, title: "Flex" },
            { path: `/utilities/gutters`, type: "link", active: false, selected: false, dirchange: false, title: "Gutters" },
            { path: `/utilities/helpers`, type: "link", active: false, selected: false, dirchange: false, title: "Helpers" },
            { path: `/utilities/position`, type: "link", active: false, selected: false, dirchange: false, title: "Position" },
            { path: `/utilities/additionalcontent`, type: "link", active: false, selected: false, dirchange: false, title: "Additional Content" },
        ],
    },


    {
        title: "Forms", icon: Forms, type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [
            {
                title: "Form Elements", type: "sub", menusub: true, active: false, selected: false, dirchange: false,
                children: [
                    { path: `/forms/formelement/input`, type: "link", active: false, selected: false, dirchange: false, title: "Inputs" },
                    { path: `/forms/formelement/checkradios`, type: "link", active: false, selected: false, dirchange: false, title: "Checks & Radios" },
                    { path: `/forms/formelement/inputgroup`, type: "link", active: false, selected: false, dirchange: false, title: "Input Group" },
                    { path: `/forms/formelement/formselect`, type: "link", active: false, selected: false, dirchange: false, title: "Form Select" },
                    { path: `/forms/formelement/rangeslider`, type: "link", active: false, selected: false, dirchange: false, title: "Range Slider" },
                    { path: `/forms/formelement/inputmasks`, type: "link", active: false, selected: false, dirchange: false, title: "Input Masks" },
                    { path: `/forms/formelement/fileupload`, type: "link", active: false, selected: false, dirchange: false, title: "File Uploads" },
                    { path: `/forms/formelement/datetimepicker`, type: "link", active: false, selected: false, dirchange: false, title: "Date, Time Picker" },
                    { path: `/forms/formelement/colorpicker`, type: "link", active: false, selected: false, dirchange: false, title: "Color Pickers" },
                ],
            },
            { path: `/forms/floatinglabels`, type: "link", active: false, selected: false, dirchange: false, title: "Floating labels" },
            { path: `/forms/formlayouts`, type: "link", active: false, selected: false, dirchange: false, title: "Form Layouts" },
            {
                title: "Form Editors", type: "sub", menusub: true, active: false, selected: false, dirchange: false,
                children: [
                    { path: `/forms/formeditor/suneditor`, type: "link", active: false, selected: false, dirchange: false, title: "Sun Editor" },
                ],
            },
            { path: `/forms/validation`, type: "link", active: false, selected: false, dirchange: false, title: "Validation" },
            { path: `/forms/select2`, type: "link", active: false, selected: false, dirchange: false, title: "Select 2" },
        ],
    },


    {
        title: "Advanced UI", icon: AdvancedUI, type: "sub", menusub: true, active: false, selected: false, dirchange: false,
        children: [
            { path: `/advancedui/accordioncollapse`, type: "link", active: false, selected: false, dirchange: false, title: "Accordions & Collapse" },
            { path: `/advancedui/carousel`, type: "link", active: false, selected: false, dirchange: false, title: "Carousel" },
            { path: `/advancedui/draggable`, type: "link", active: false, selected: false, dirchange: false, title: "Draggable Cards" },
            { path: `/advancedui/modalcloses`, type: "link", active: false, selected: false, dirchange: false, title: "Modals & Closes" },
            { path: `/advancedui/navbar`, type: "link", active: false, selected: false, dirchange: false, title: "Navbar" },
            { path: `/advancedui/offcanvas`, type: "link", active: false, selected: false, dirchange: false, title: "Offcanvas" },
            { path: `/advancedui/placeholder`, type: "link", active: false, selected: false, dirchange: false, title: "Placeholders" },
            { path: `/advancedui/ratings`, type: "link", active: false, selected: false, dirchange: false, title: "Ratings" },
            { path: `/advancedui/swiperjs`, type: "link", active: false, selected: false, dirchange: false, title: "Swiper JS" },
        ],
    },



    { path: `/widget`, title: "Widgets", icon: Widgets, type: "link", active: false, selected: false, dirchange: false },


    {
        title: "Tables", icon: Tables, type: "sub", menusub: true, active: false, selected: false, dirchange: false,
        children: [
            { path: `/tables/tables`, type: "link", active: false, selected: false, dirchange: false, title: "Tables" },
            { path: `/tables/gridjstables`, type: "link", active: false, selected: false, dirchange: false, title: "Grid JS Tables" },
            { path: `/tables/datatables`, type: "link", active: false, selected: false, dirchange: false, title: "Data Tables" },
        ],
    },

    {
        title: "Charts", icon: Charts, type: "sub", menusub: true, active: false, selected: false, dirchange: false,
        children: [
            {
                title: "Apex Charts", type: "sub", menusub: true, active: false, selected: false, dirchange: false, children: [

                    { path: `/charts/apexchart/Linechart`, type: "link", active: false, selected: false, dirchange: false, title: "Line Charts" },
                    { path: `/charts/apexchart/Areachart`, type: "link", active: false, selected: false, dirchange: false, title: "Area Charts" },
                    { path: `/charts/apexchart/Columnchart`, type: "link", active: false, selected: false, dirchange: false, title: "Column Charts" },
                    { path: `/charts/apexchart/Barchart`, type: "link", active: false, selected: false, dirchange: false, title: "Bar Charts" },
                    { path: `/charts/apexchart/Mixedchart`, type: "link", active: false, selected: false, dirchange: false, title: "Mixed Charts" },
                    { path: `/charts/apexchart/Rangeareachart`, type: "link", active: false, selected: false, dirchange: false, title: "Range Area Charts" },
                    { path: `/charts/apexchart/Timelinechart`, type: "link", active: false, selected: false, dirchange: false, title: "Timeline Charts" },
                    { path: `/charts/apexchart/FunnelChart`, type: "link", active: false, selected: false, dirchange: false, title: "Funnel Chart" },
                    { path: `/charts/apexchart/Candlestickchart`, type: "link", active: false, selected: false, dirchange: false, title: "CandleStick Charts" },
                    { path: `/charts/apexchart/Boxplotchart`, type: "link", active: false, selected: false, dirchange: false, title: "Boxplot Charts" },
                    { path: `/charts/apexchart/Bubblechart`, type: "link", active: false, selected: false, dirchange: false, title: "Bubble Charts" },
                    { path: `/charts/apexchart/Scatterchart`, type: "link", active: false, selected: false, dirchange: false, title: "Scatter Charts" },
                    { path: `/charts/apexchart/Heatmapchart`, type: "link", active: false, selected: false, dirchange: false, title: "Heatmap Charts" },
                    { path: `/charts/apexchart/Treemapchart`, type: "link", active: false, selected: false, dirchange: false, title: "Treemap Charts" },
                    { path: `/charts/apexchart/Piechart`, type: "link", active: false, selected: false, dirchange: false, title: "Pie Charts" },
                    { path: `/charts/apexchart/Radialbarchart`, type: "link", active: false, selected: false, dirchange: false, title: "Radialbar Charts" },
                    { path: `/charts/apexchart/Radarchart`, type: "link", active: false, selected: false, dirchange: false, title: "Radar Charts" },
                    { path: `/charts/apexchart/Polarareachart`, type: "link", active: false, selected: false, dirchange: false, title: "Polararea Charts" },
                ],
            },
            { path: `/charts/chartjs`, type: "link", active: false, selected: false, dirchange: false, title: "ChartJS" },
            { path: `/charts/echart`, type: "link", active: false, selected: false, dirchange: false, title: "Echart Charts" },
        ],
    },


    {
        title: "Maps", icon: Maps, type: "sub", menusub: true, active: false, selected: false, dirchange: false,
        children: [
            { path: `/maps/leafletmaps`, type: "link", active: false, selected: false, dirchange: false, title: "Leaflet Maps" },
            { path: `/maps/pigeonmaps`, type: "link", active: false, selected: false, dirchange: false, title: "Pigeon Maps" },
        ],
    },



    { path: `/icons`, title: "Icons", icon: Icons, type: "link", active: false, selected: false, dirchange: false },

];

const createMenuLink = (path: string, title: string): Menuitemtype => ({
    path,
    type: "link",
    active: false,
    selected: false,
    dirchange: false,
    title,
});

export const getMenuItems = (): Menuitemtype[] => [
    ...(() => {
        const caresBootstrap = getCaresShellBootstrap();
        const shippedAdminSectionIds = new Set(['overview', 'clients', 'users-access', 'theme-options', 'audit-activity']);
        const adminThemeSections = adminSections.filter((section) => section.id === 'theme-options');
        const adminPrimarySections = adminSections.filter((section) =>
            shippedAdminSectionIds.has(section.id) && section.id !== 'theme-options'
        );
        return [
    ...(caresBootstrap.navigation.mySchedule ? [{
        title: "My Schedule",
        icon: MyDashboardIcon,
        type: "sub" as const,
        menusub: true,
        active: false,
        selected: false,
        dirchange: false,
        children: myScheduleSections.map((section) => createMenuLink(section.path, section.navLabel)),
    }] : []),
    ...(caresBootstrap.navigation.admin ? [{
        title: "CARES Administration",
        icon: AdminIcon,
        type: "sub" as const,
        menusub: true,
        active: false,
        selected: false,
        dirchange: false,
        children: [
            ...adminPrimarySections.map((section) => createMenuLink(section.path, section.navLabel)),
            {
                title: "System Settings",
                type: "sub" as const,
                menusub: true,
                active: false,
                selected: false,
                dirchange: false,
                children: adminThemeSections.map((section) => createMenuLink(section.path, section.navLabel)),
            },
        ],
    }] : []),
    ...(caresBootstrap.navigation.adminSettings ? [{
        title: "Company Admin Settings",
        icon: AdminSettingsIcon,
        type: "sub" as const,
        menusub: true,
        active: false,
        selected: false,
        dirchange: false,
        children: adminSettingsSections.map((section) => createMenuLink(section.path, section.navLabel)),
    }] : []),
    ...(caresBootstrap.navigation.schedulerReview || caresBootstrap.navigation.scheduleSettings ? [{
        title: "Scheduling",
        icon: SchedulingIcon,
        type: "sub" as const,
        menusub: true,
        active: false,
        selected: false,
        dirchange: false,
        children: [
            ...(caresBootstrap.navigation.scheduleSettings
                ? [createMenuLink('/scheduling/overview', 'Overview')]
                : []),
            ...(caresBootstrap.navigation.schedulerReview
                ? [
                    createMenuLink('/scheduling/group-schedule', 'Department Schedule'),
                    createMenuLink('/scheduling/group-tallies', 'Department Tallies'),
                    createMenuLink('/scheduling/request-queue', 'Request Queue'),
                    createMenuLink('/scheduling/draft-review', 'Review Schedule Draft'),
                ]
                : []),
            ...(caresBootstrap.navigation.scheduleSettings
                ? [createMenuLink('/scheduling/settings/locations', 'Department Schedule Settings')]
                : []),
        ],
    }] : []),
    ...(caresBootstrap.authenticated ? [{
        path: "/user-settings",
        title: "User Settings",
        icon: UserSettingsIcon,
        type: "link" as const,
        active: false,
        selected: false,
        dirchange: false,
    }] : []),
    ...(caresBootstrap.navigation.faq ? [{
        title: "Help",
        icon: FaqIcon,
        type: "sub" as const,
        menusub: true,
        active: false,
        selected: false,
        dirchange: false,
        children: [
            createMenuLink("/faq", "CARES Help"),
        ],
    }] : []),
    ...(caresBootstrap.navigation.admin ? [{
        title: "Template Reference",
        icon: TemplateItemsIcon,
        type: "sub" as const,
        menusub: true,
        active: false,
        selected: false,
        dirchange: false,
        children: TEMPLATE_MENU_ITEMS,
    }] : []),
        ];
    })(),
];

export const MENUITEMS: Menuitemtype[] = getMenuItems();


//Landing page menubar data

export interface MenuItem {
    label: string;
    type: string;
    path?: string;
    isOpen?: boolean;
    class?: string;
    childrenClass?: string;
    children?: MenuItem[];
}

export const LandingMenuData: MenuItem[] = [
    { label: 'Home', type: 'link', path: '#home' },
    { label: 'About', type: 'link', path: '#about' },
    { label: 'Pricing', type: 'link', path: '#pricing' },
    { label: 'Team', type: 'link', path: '#team' },
    { label: 'Faq\'s', type: 'link', path: '#faqs' },
    { label: 'Testimonials', type: 'link', path: '#testimonials' },
    { label: 'Contact Us', type: 'link', path: '#contact' },
];


export const JobLandingMenuData: MenuItem[] = [
    { label: 'Home', type: 'link', path: '#home' },
    { label: 'Jobs', type: 'link', path: '#jobs' },
    { label: 'Candidates', type: 'link', path: '#candidate' },
    { label: 'For Employers', type: 'link', path: '#employers' },
    { label: 'Career Advice', type: 'link', path: '#career-advice' },
];
